import { JSXElementConstructor } from 'react';
import { LoadingIndicator } from '@carbonify/ui';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';

import styles from './LoadingOverlay.module.css';

interface Props {
  status?: 'loading' | 'connecting' | 'connected' | 'closed' | 'redirected';
  error?: string;
  details?: string;
  icon?: JSXElementConstructor<any>;
}

export default function LoadingOverlay({ status = 'loading', error, icon, details }: Props) {
  if (!error && ['connected', 'closed'].includes(status)) return null;

  const label = error || (status === 'connecting' ? 'Connecting...' : 'Loading preview...');
  const Icon = icon || (error ? ExclamationCircleIcon : LoadingIndicator);

  return (
    <div
      className={styles.overlay}
      role={error ? 'alert' : 'status'}
      aria-live={error ? 'assertive' : 'polite'}
    >
      {error ? (
        <Icon
          className={clsx(styles.icon, styles[status])}
          aria-hidden
        />
      ) : (
        <Icon
          size="lg"
          aria-label={label}
        />
      )}
      <span className={styles.label}>{label}</span>
      {details && (
        <code className={styles.details}>
          <pre>{details}</pre>
        </code>
      )}
    </div>
  );
}
